import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <p>&copy; 2026 Cleany Admin — cyber operations grid online.</p>
        </footer>
    );
};

export default Footer;